__turbopack_context__.v({
  "className": "playfair_display_647c447-module__4yYb1G__className",
});
